/* eslint semi:0 */
import BaseVm from 'vms/BaseVm'
import { isDesktop, isTablet, } from 'utils/ua'
import navbarActions from 'actions/navbarActions'
import { getSingleElementByClass, } from 'utils/dom'
import socialButtonsConf from 'config/socialButtonsConfig'
import scrollingEventsProvider from 'providers/scrollingEventsProvider'
import { wrapButtonInLabel, } from 'views/ButtonView';


let scrollingEvents = [
  {
    element: getSingleElementByClass('share-component'),
    triggerPosition: {
      bottom: 0, // height percentage from top
      // bottom: 100, // height percentage from bottom
    },
    event: 'coverSharedIconsReached',
    relativeTopElement: getSingleElementByClass('header-container'),
  },
  {
    element: getSingleElementByClass('post-article__post-title'),
    triggerPosition: {
      bottom: 0, // height percentage from top
      // bottom: 100, // height percentage from bottom
    },
    event: 'postTitleReached',
    relativeTopElement: getSingleElementByClass('header-container'),
  },
]


export default class NavbarVm extends BaseVm {

  onChange(payload){
    if (payload && payload.topHeight) {
      this.mobileHeaderTop = payload.topHeight
    }
    super.onChange(payload)
  }

  get mobileHeaderTop(){ return this.state.mobileHeaderTop || 0 }
  set mobileHeaderTop(topHeight){ this.state.mobileHeaderTop = topHeight }
  get mobileHeaderRepositioned() { return this.state.mobileHeaderRepositioned }
  set mobileHeaderRepositioned(bool){ this.state.mobileHeaderRepositioned = bool }

  coverSharedIconsReached(scrollingEventObject){
    navbarActions.socialComponentScrollerReached(scrollingEventObject)
  }

  postTitleReached(scrollingEventObject){
    navbarActions.titleScrollerReached(scrollingEventObject)
  }

  registerScrollingActions(){
    let vm = this
    scrollingEvents.forEach(function(eventConfig){
      eventConfig.vm = vm
      scrollingEventsProvider.register(eventConfig)
    });
    return this
  }

  getVisibleButtons(){
    let { facebook, twitter, whatsapp, embed, comments, } = socialButtonsConf;
    const baseButtons = [twitter, facebook, ];
    let result;
    switch(true){
      case isDesktop:
        result = [ comments, ...baseButtons, ];
        break;
      default:
        result = baseButtons;
        break;
    }
    return result.map(wrapButtonInLabel);
  }

}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/NavbarVM.js